import moment from 'moment';
import { isArray, forOwn, isEmpty } from 'lodash';
import { CONFIGURATIONS_FIELD_NAME, OPERATOR_NAMES } from './QueryBuilder/constants';
import uiLabelsPaths from '../../services/uiFieldLabelsDictionary';
import { FORMAT_FOR_API } from '../../constants/commonConstants';

const fieldToOperator = {
  c_uuid: OPERATOR_NAMES.contains,
  c_uuid_contains: OPERATOR_NAMES.contains,
  name: OPERATOR_NAMES.contains,
  country_contains: OPERATOR_NAMES.contains,
  address: OPERATOR_NAMES.contains,
  contact: OPERATOR_NAMES.contains,
  details: OPERATOR_NAMES.contains,
  user_name: OPERATOR_NAMES.contains,
  fw_version: OPERATOR_NAMES.contains,
  product_serial_number: OPERATOR_NAMES.contains,
  current_firmware_version: OPERATOR_NAMES.contains,
  new_firmware_version: OPERATOR_NAMES.contains,
  configuration_update_username: OPERATOR_NAMES.contains,
  time: OPERATOR_NAMES.dateEquals,
  warranty_end: OPERATOR_NAMES.dateEquals,
  request_time: OPERATOR_NAMES.dateEquals,
  end_time: OPERATOR_NAMES.dateEquals,
  configuration_update_ts: OPERATOR_NAMES.dateEquals,
  f_status: OPERATOR_NAMES.anyOf,
  customer_id: OPERATOR_NAMES.equals,
};

export const nodeConfigurationsValues = {
  config_node_name: 'Node Name',
  parameter_name: 'Parameter Name',
  parameter_value: 'Value',
};

export const TABS = {
  CHARGER: 'charger',
  CONFIGURATION: 'configuration',
};

export const emptyFilter = {
  operator: 'AND',
  conditions: [],
};

export const getConfigurationPayload = ({ operator, conditions }) => {
  const paramFilters = conditions.map((condition) => {
    if (condition.conditions) {
      const nodeNameCondition = condition.conditions.find(({ field }) => field === CONFIGURATIONS_FIELD_NAME.nodeName);
      const nestedCondition = condition.conditions.filter(({ field }) => field !== CONFIGURATIONS_FIELD_NAME.nodeName);

      const updatedConditions = [
        {
          operator: 'AND',
          conditions: nestedCondition,
        },
      ];

      if (nodeNameCondition) {
        updatedConditions.push(nodeNameCondition);
      }

      return {
        operator: condition.operator,
        conditions: updatedConditions,
      };
    }

    return condition;
  });

  return {
    searchOperator: operator,
    paramFilters,
  };
};

export const fillChargersFilter = (simpleFilter, advancedFilter) => {
  if (isArray(simpleFilter)) {
    simpleFilter = simpleFilter.reduce((acc, { id, value }) => {
      acc[id] = value;

      return acc;
    }, {});
  }

  forOwn(simpleFilter, (value, field) => {
    const operator = fieldToOperator[field] || OPERATOR_NAMES.equals;

    if (['time', 'configuration_update_ts'].includes(field)) {
      value = moment.utc(value, FORMAT_FOR_API).valueOf();
    } else if (field === 'warranty_end' || field === 'request_time' || field === 'end_time') {
      value = Number(value);
    }

    if (field === 'selectedFwVer' && value !== 'No FW Version') {
      advancedFilter.conditions.push({ field: 'fw_version', operator: OPERATOR_NAMES.equals, value });
    } else if (field === 'selectedFwVer' && value === 'No FW Version') {
      advancedFilter.conditions.push({ field: 'fw_version', operator: OPERATOR_NAMES.empty });
    } else if (field === 'customerId') {
      advancedFilter.conditions.push({ field: 'customer_id', operator, value });
    } else if (field === uiLabelsPaths.p_type) {
      advancedFilter.conditions.push({
        field: uiLabelsPaths.p_type,
        operator: Array.isArray(value) ? OPERATOR_NAMES.anyOf : OPERATOR_NAMES.equals,
        value: isEmpty(value) ? [] : value,
      });
    } else {
      advancedFilter.conditions.push({ field, operator, value });
    }
  });
};
